export default {
    // General
    loading: 'Loading',
    home: 'Home',
    back: 'Back',
    confirm: 'Confirm',
    cancel: 'Cancel',
    close: 'Close',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    yes: 'Yes',
    no: 'No',
    or: 'or',
    and: 'and',
    required: 'Required',
    optional: 'Optional',

    // Store status
    storeOpen: 'Open',
    storeClosed: 'Closed',
    storeOpenSoon: 'Opening soon',

    // Navigation
    categories: 'Categories',
    siteMap: 'Site map',
    cart: 'Cart',
    myAccount: 'My account',

    // Auth
    login: 'Log in',
    register: 'Sign up',
    logout: 'Log out',
    forgotPassword: 'Forgot password?',
    rememberMe: 'Remember me',
    alreadyHaveAccount: 'Already have an account?',
    noAccount: "Don't have an account?",
    signIn: 'Sign in',

    // Form fields
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm password',
    firstName: 'First name',
    lastName: 'Last name',
    phone: 'Phone',
    address: 'Address',
    city: 'City',
    postalCode: 'Postal code',
    country: 'Country',

    // Password rules
    passwordRules: 'Password must contain: at least 10 characters, one uppercase, one lowercase, one number, one special character',
    confirmPasswordMessage: 'Please confirm your password',
    passwordValid: 'Password valid',
    passwordInvalid: 'Password invalid',
    passwordMismatch: 'Passwords do not match',
    passwordMissingLength: 'at least {min} characters',
    passwordMissingUppercase: 'one uppercase letter',
    passwordMissingLowercase: 'one lowercase letter',
    passwordMissingNumber: 'one number',
    passwordMissingSpecial: 'one special character',
    optionFreeRemaining: 'You can still select {count} free option!',
    optionSelectAtLeastOne: 'You must select at least one option!',
    optionSelectionRequired: 'A selection is required for this option!',
    mustAcceptTerms: 'You must accept the terms of use.',
    registerFormAlreadySubmitted: 'The registration form has been submitted, please wait!',
    newPassword: 'New password',
    oldPassword: 'Old password',
    verifyingInfo: 'We are verifying your information',
    contactUs: 'Please contact us!',
    invalidInfo: 'Your information is invalid',
    deleteAccountRequest: 'Account deletion request',
    deleteAccountConfirmText: 'If you want to delete your account, please enter your password',

    // Terms
    acceptTerms: 'Accept terms and conditions',
    privacyPolicy: 'Privacy Policy',
    termsOfUse: 'Terms of Use',

    // Product
    select: 'Select',
    addToCart: 'Add',
    options: 'Options',
    description: 'Description',
    noDescription: 'No description available',
    nameUnavailable: 'Name unavailable',
    someOptionsPaid: 'some options are paid',

    // Cart / Order
    cartTitle: 'Cart',
    cartSummary: 'Cart summary',
    orderCommand: 'Order',
    validateOrder: 'Confirm order',
    total: 'Total',
    subtotal: 'Subtotal',
    deliveryFees: 'Delivery fees',
    free: 'free',
    paid: 'paid',
    orderPaid: 'Paid',
    orderUnpaid: 'Unpaid',
    maximum: 'maximum',
    quantity: 'Quantity',

    // Payment
    payByCard: 'Pay by card',
    payOnSite: 'Pay on site',
    paymentSuccess: 'Payment successful',
    paymentError: 'Payment error',

    // Delivery
    delivery: 'Delivery',
    pickup: 'Takeaway',
    tableReservation: 'Table reservation',
    deliveryZones: 'Delivery zones',
    deliveryFee: 'Delivery fee',
    minimumOrder: 'Minimum order',
    freeFrom: 'Free delivery from',

    // Dashboard
    dashboard: 'Dashboard',
    orderHistory: 'Order history',
    addressBook: 'Address book',
    setDefault: 'Set default',
    requestAccessCode: 'Request a code to access your account',
    code: 'Code',
    myInfo: 'My information',
    myAddresses: 'My addresses',
    addAddress: 'Add address',
    editAddress: 'Edit address',
    deleteAddress: 'Delete address',
    deleteAccount: 'Delete my account',
    modifyPassword: 'Change password',
    cancelAccountDeletion: 'Cancel account deletion',
    loginToOrder: 'You must be logged in to place an order',
    send: 'Send',
    missingFields: 'Missing or invalid field(s)',
    forgotPasswordDescription: 'Enter your email address to reset your password',
    enterEmail: 'Enter your email address',
    forgotPasswordTitle: 'Forgot password',
    passwordResetTitle: 'Password reset',
    disconnectSuccess: 'Successfully logged out',
    captchaRequired: 'Please complete the captcha',
    captchaLoading: 'Loading captcha...',
    captchaError: 'Captcha error. Please try again.',
    retry: 'Retry',
    productAddedSuccess: 'Your product has been added!',
    productAssociatedSuggestion: 'Customers also recommend these products to go with your selection.',
    productAssociatedTitle: 'Related product(s)',
    removeProductQuestion: 'Do you want to remove this product from the cart?',
    waitBeforeRetry: 'Please wait before clicking again',
    fillRequiredFields: 'Please fill in all required fields',
    otpInvalid: 'Please enter a valid OTP code',
    otpSendError: 'Error while sending the OTP code',
    infoUnchanged: 'Information has not changed',
    selectAddressToModify: 'Please select an address to modify',
    orderPlacedSuccess: 'Order placed successfully!',
    paymentSuccessMessage: 'Congratulations, your payment was successful!',
    orderTransmittedRestaurant: 'Your order has been sent to the restaurant',
    orderNumberLabel: 'Order number:',
    pickupOrderMessage: 'You can pick up your order at:',
    wishGoodDayMeal: 'Wishing you a good day and a pleasant meal',
    wishGoodAfternoonMeal: 'Wishing you a good afternoon and a pleasant meal',
    wishGoodEveningMeal: 'Wishing you a good evening and a pleasant meal',
    addressNotFound: 'Address not found',
    accountDeletionTitle: 'Account deletion',
    accountDeletionCancelError: 'Error canceling account deletion',
    personalInfoTitle: 'Personal information',
    selectAddressTitle: 'Select an address',
    selectedAddressNotFound: 'The selected address was not found',
    todayOrders: "Today's Orders",
    previousOrders: 'Previous Orders',
    order: 'Order',
    pickupTime: 'Pickup Time',
    notConfirmed: 'Not confirmed',
    cancelled: 'Cancelled',
    company: 'Company',
    addressComplement: 'Address complement',
    region: 'Region',
    selectRegion: 'Select a region',
    selectCity: 'Select a city',
    address1: 'Address 1',
    // refactored — address form'a özel key'ler.
    addressFormZoneLabel: 'Region',
    addressFormCityLabel: 'City',
    addressFormStreetLabel: 'Street',
    addressFormSelectZone: 'Select a region',
    addressFormSelectCity: 'Select a city',
    addressSearchPlaceholder: 'Search an address (street, avenue, building…)',
    addressMapHint: 'Click the map or drag the marker to pick the exact point.',
    addressMapPicked: 'Selected location',
    defaultAddressQuestion: 'Default address',
    mandatory: 'Required',
    noOrdersYet: 'You have no orders yet',
    noAddressesYet: 'You have no saved addresses yet',
    cartEmpty: 'Cart is empty',
    storeClosedLong: 'The store is closed',

    // Order validation page
    fullName: 'Full name',
    orderOptions: 'Order options',
    pickupMethod: 'Pickup method',
    withdrawTitle: 'Pickup',
    paymentMethod: 'Payment method',
    asSoonAsPossible: 'As soon as possible',
    todayLabel: 'Today',
    existingAddress: 'Existing address',
    newAddress: 'New address',
    addressAddedSuccess: 'Your new address has been added successfully.',
    selectDeliveryAddress: 'Please select a delivery address.',
    priceDoesntMeetDelivery: 'The price does not meet the delivery conditions',
    restaurantDoesntAcceptPickupDelivery: 'The restaurant does not accept pickup or delivery',
    storeCannotTakeOrderNow: 'The restaurant cannot take your order right now. Please try again later',
    cardMinimumAmount: 'To order by card, the total amount must be {amount} or more.',
    hourLabel: 'Hour',
    minuteLabel: 'Minute',
    addressPlaceholder: 'Address',
    emptyBasketProducts: 'No products in the cart',
    taxIncluded: 'VAT ({rate}%) Included',
    shippingTaxIncluded: 'Delivery fee VAT ({rate}%) Included',
    withShippingFees: 'with delivery fees',
    addCommentPlaceholder: 'You can add a comment',
    demoCannotOrder: 'This site is a demo, you cannot place an order',
    demoCannotPassOrder: 'You cannot place an order, this site is a demo',
    validateInformationButton: 'Validate information',
    termsValidationIntro: 'By validating this order, you confirm that you have read and accepted our',
    termsValidationMiddle: 'as well as our',
    termsValidationEnd: 'We encourage you to read them carefully before finalizing your purchase',

    // Store status banner
    storeOpensAt: 'Opens at {time}',
    storeClosedOpensOn: 'Closed, opens {day} at {time}',
    storeOrderOpenOpensAt: 'The ordering system is active, you can place your order now and pick it up from {time}.',
    storeOpenOrderClosed: 'Store Open - Ordering Closed',
    dayFullSunday: 'Sunday',
    dayFullMonday: 'Monday',
    dayFullTuesday: 'Tuesday',
    dayFullWednesday: 'Wednesday',
    dayFullThursday: 'Thursday',
    dayFullFriday: 'Friday',
    dayFullSaturday: 'Saturday',

    // Order status
    orderPending: 'Pending',
    orderPreparation: 'In preparation',
    orderReady: 'Ready',
    orderDelivered: 'Delivered',
    orderCancelled: 'Cancelled',

    // Footer
    openingHours: 'Opening hours',
    pickupService: 'Pickup hours',
    deliveryService: 'Delivery hours',
    allRightsReserved: 'All rights reserved',
    dayShortMon: 'Mon',
    dayShortTue: 'Tue',
    dayShortWed: 'Wed',
    dayShortThu: 'Thu',
    dayShortFri: 'Fri',
    dayShortSat: 'Sat',
    dayShortSun: 'Sun',

    // Errors
    error: 'Error',
    attention: 'Attention',
    networkError: 'Network error',
    unauthorized: 'Unauthorized',

    // Validation errors (backend keys)
    phone_missing: 'Phone number is missing',
    phone_invalid: 'Phone number is invalid',
    lastname_missing: 'Last name is missing',
    lastname_invalid: 'Last name is invalid',
    firstname_missing: 'First name is missing',
    firstname_invalid: 'First name is invalid',
    password_missing: 'Password is missing',
    password_rules_violated: 'Password does not meet the rules',
    password_confirm_missing: 'Password confirmation is missing',
    password_confirm_rules_violated: 'Password confirmation does not meet the rules',
    password_mismatch: 'Passwords do not match',
    store_name_missing: 'Store name is missing',
    store_name_invalid: 'Store name is invalid',
    language_missing: 'Language is missing',
    language_invalid: 'Language is invalid',
    customer_missing: 'Customer information is missing',
    customer_invalid: 'Customer information is invalid',
    store_missing: 'Store information is missing',
    store_invalid: 'Store information is invalid',
    remember_me_invalid: '"Remember me" option is invalid',
    email_missing: 'Email address is missing',
    email_invalid: 'Email address is invalid',
    email_domain_invalid: 'Email domain is invalid',
    address_fields_missing: 'Address fields are missing',
    zone_missing: 'Zone is missing',
    city_missing: 'City is missing',
    city_invalid: 'City is invalid',
    city_too_short: 'City is too short',
    city_too_long: 'City is too long',
    supaddress_missing: 'Address complement is missing',
    supaddress_too_short: 'Address complement is too short',
    supaddress_too_long: 'Address complement is too long',
    supaddress_invalid: 'Address complement is invalid',
    address_missing: 'Address is missing',
    address_too_short: 'Address is too short',
    address_too_long: 'Address is too long',
    address_invalid: 'Address is invalid',
    company_name_too_short: 'Company name is too short',
    company_name_too_long: 'Company name is too long',
    company_name_invalid: 'Company name is invalid',
    address_id_missing: 'Address ID is missing',
    address_id_invalid: 'Address ID is invalid',

    // Backend messages (snake_case keys)
    invalid_data: 'Invalid data',
    terms_not_accepted: 'You must accept the terms and conditions',
    generic_error: 'An error occurred! If the problem persists, please contact the store.',
    session_expired: 'Your session has expired. Please log in again.',
    token_invalid_or_expired: 'Token is invalid or expired',
    refresh_token_missing: 'Refresh token is missing',
    refresh_token_invalid: 'Refresh token is invalid or expired',
    token_refresh_success: 'Token refreshed successfully',
    captcha_failed: 'Captcha verification failed',
    email_already_used: 'This email is already in use',
    register_error_generic: 'An error occurred while creating the account',
    register_error_retry: 'An error occurred while creating your account, please try again',
    register_success_verify_email: 'Registration successful. Please verify your email',
    confirm_register_error: 'Registration confirmation error',
    store_id_invalid: 'Store identifier is invalid',
    store_id_mismatch: 'Store identifier does not match',
    store_not_found: 'Store not found',
    store_setting_not_found: 'Setting not found',
    store_privacy_policy_not_found: 'Privacy policy not found',
    store_condition_use_not_found: 'Terms of use not found',
    store_theme_not_found: 'Theme not found',
    store_no_categories: 'No categories associated with this store',
    store_no_category_ids: 'No categories found with these identifiers',
    store_load_error: 'An error occurred while loading the store data',
    user_not_found: 'User not found',
    customer_id_invalid: 'User identifier is invalid',
    customer_id_missing: 'User identifier is missing',
    customer_fetch_error: 'An error occurred while retrieving user information',
    customer_error_generic: 'User error',
    customer_data_missing: 'Customer data is missing',
    customer_data_invalid: 'Customer data is invalid',
    email_not_verified: 'The user has not verified their email',
    email_not_verified_cannot_modify_password: 'Please verify your email before making any changes',
    email_or_password_invalid: 'Email or password is invalid.',
    email_or_store_invalid: 'Email or store is invalid',
    email_already_confirmed: 'You have already confirmed your email',
    email_confirmed_success: 'Your email is verified, you will be redirected',
    password_incorrect: 'Password is incorrect',
    password_invalid: 'Password is invalid.',
    old_password_invalid: 'The old password is invalid',
    password_reset_link_active: 'A password reset link is active',
    reset_link_already_active: 'A reset link is already active. Please check your email',
    reset_token_expired: 'The modification has expired, please make a new request',
    reset_token_expired_retry: 'Token is invalid or expired, please make a new request',
    forget_password_email_sent: 'You will receive an email to change your password',
    forget_password_error: 'Error while processing the forgot password request',
    password_reset_success: 'Your password has been successfully changed!',
    password_reset_error: 'Error while updating the forgotten password',
    user_cannot_change_password: 'The user cannot change their password!',
    user_cannot_modify_password: 'The user cannot modify their password',
    verify_modify_success: 'The user can change their password',
    update_success: 'Information was updated successfully.',
    update_error: 'Error while updating the data!',
    update_password_success: 'Password updated successfully.',
    update_password_success_redirect: 'Your password has been changed, you will be redirected',
    update_password_error: 'Error while updating the password',
    user_pending_deletion: 'The user has requested account deletion',
    account_pending_deletion_service_denied: 'Your account has an active deletion request',
    user_no_deletion_request: 'The user has not requested account deletion',
    user_archived: 'The user has been archived',
    user_deleted_success: 'Your account has been successfully deleted',
    delete_user_error: 'An error occurred while deleting your account',
    delete_request_success: 'Your account deletion request has been recorded',
    delete_request_error: 'An error occurred during the account deletion request.',
    cancel_delete_success: 'Your account deletion request has been successfully canceled.',
    cancel_delete_success_with_warning: 'The account deletion request has been successfully canceled. For better security, please update your password.',
    account_verification_error: 'An error occurred during account verification.',
    login_success: 'Login successful, you will be redirected',
    login_success_old_password: 'Login successful, you will be redirected. For better security, please update your password',
    login_error_generic: 'An error occurred during your login attempt',
    disconnect_success: 'Successfully logged out',
    disconnect_error: 'An error occurred during logout',
    me_success: 'Information retrieved successfully',
    fetch_me_error: 'An error occurred while retrieving your information.',
    otp_request_success: 'Code request is valid',
    otp_request_error: 'An error occurred during the code request.',
    otp_valid: 'Valid code, you may modify your information',
    otp_invalid: 'Invalid code, please check your code',
    otp_already_used: 'You have already used your access code',
    otp_verification_error: 'An error occurred during code verification.',
    otp_verification_success: 'The access code has been successfully verified.',
    otp_send_success: 'The access code has been sent by email.',
    otp_send_error: 'An error occurred while sending the access code',
    city_or_postal_invalid: 'The city or postal code is invalid',
    address_duplicate: 'An identical address already exists for this city.',
    address_not_found: 'This address does not exist',
    address_not_found_for_customer: 'No address found for this customer.',
    address_id_missing_or_invalid: 'The address identifier is invalid or missing',
    address_limit_reached: 'You have reached the maximum number of allowed addresses.',
    address_added_success: 'Your address has been successfully saved.',
    address_added_success_default: 'Your address has been saved as default.',
    address_added_error: 'An error occurred while adding the address',
    address_update_success: 'Your address has been updated',
    address_update_success_default: 'Your address has been updated and saved as default',
    address_update_error: 'An error occurred while updating the address',
    address_delete_success: 'The address has been deleted',
    address_delete_error: 'Error while deleting the address',
    address_fetch_error: 'Error while retrieving address data!',
    order_too_many_requests: 'Too many requests. Please wait before trying again.',
    order_price_mismatch: 'The submitted price does not match the data.',
    order_created_success: 'Order created',
    order_creation_error: 'Error while creating the order',
    order_cancelled_success: 'Order modified',
    order_cancel_error: 'Error',
    order_id_missing: 'Order ID is missing',
    order_id_invalid: 'Order ID is invalid',
    orders_not_found: 'No orders found',
    orders_fetch_success: 'Orders retrieved successfully',
    order_stripe_failed: 'Payment session creation failed. Please contact the restaurant.',
    pay: 'Pay',
    amountUnavailable: 'Amount unavailable',

    // Legal pages (CGU / Privacy Policy)
    cguTitle: 'Terms of use',
    privacyTitle: 'Privacy policy',
    lastUpdated: 'Last update:',
    cguIntro: "These terms of use govern the use of the https://{hostname} website and its services. By accessing and using this site, you agree to be bound by these terms. If you do not accept these terms, please do not use our site.",
    privacyWelcomeBefore: 'Welcome to ',
    privacyWelcomeAfter: ', we offer an online ordering service.',
    privacyIntro: 'This privacy policy explains how we collect, use, and protect your personal data.',
    contactLabel: 'Contact:',

    // Page titles (browser tab)
    productCatalog: 'Product catalog',
    productDetails: 'Product',
    registerTitle: 'Registration',
    confirmRegistration: 'Registration confirmation',
    cartOrderTitle: 'Cart - Order',
    dashboardEditInfo: 'Dashboard - Edit personal information',
    dashboardEditPassword: 'Dashboard - Change password',
    dashboardAddresses: 'Dashboard - Address management',
    dashboardOrders: 'Dashboard - Order history',

    // Language names
    languages: {
        tr: 'Türkçe',
        fr: 'Français',
        en: 'English',
        de: 'Deutsch'
    }
}
